module.exports = __webpack_public_path__ + "img/image_of_content_top.9797ca2d.jpg";